<template>
  <div>
    <delete-modal :yesFunc="deleteItem" ref="deleteModalRef" />
    <v-dialog v-model="userDetailModal" persistent max-width="600">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t("title.rescueMembers") }}
          </div>
        </v-card-title>
        <v-list class="mt-2" subheader>
          <v-list-item
            v-for="(item, index) in this.detailTeam.Members"
            :key="index"
          >
            <v-list-item-avatar>
              <v-img :src="item.Avatar"></v-img>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="item.FullName"></v-list-item-title>

              <v-list-item-subtitle
                v-text="item.PhoneNo"
              ></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn icon>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      @click="openDeleteModal(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>{{ $t("labels.tooltipDelete") }}</span>
                </v-tooltip>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="grey" outlined large @click="userDetailModal = false">
            {{ $t("buttons.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addMemberModal" persistent max-width="600">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t("title.addMember") }}
          </div>
        </v-card-title>

        <v-combobox
          class="mx-5 my-5"
          v-model="selectedAdmins"
          :items="adminUsers"
          label="Ekip Üyesi Ekle"
          item-value="Id"
          item-text="FullName"
          multiple
        ></v-combobox>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green"
            elevation="0"
            class="ma-2 mr-4"
            :disabled="selectedAdmins == null"
            outlined
            large
            @click="addMembers()"
          >
            {{ $t("buttons.add") }}
          </v-btn>
          <v-btn
            color="grey"
            elevation="0"
            class="ma-2 mr-4"
            outlined
            large
            @click="closeModal()"
          >
            {{ $t("buttons.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="addRescueModal" max-width="500">
      <v-card>
        <v-card-title class="headline indigo lighten-2">
          <div class="text-center white--text" style="width: 100%">
            {{ $t("title.createNewRescue") }}
          </div>
        </v-card-title>
        <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
          <form @submit.prevent="handleSubmit(addNewRescue())">
            <v-card-text class="pt-4 text-center d-flex justify-center">
              <div class="text-center" style="width: 100% !important">
                <ValidationProvider
                  :name="$t('labels.teamName')"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="TeamName"
                    :label="$t('labels.teamName')"
                    outlined
                    :error-messages="errors[0]"
                  ></v-text-field>
                </ValidationProvider>

                <v-btn
                  small
                  class="ma-2 mr-4"
                  type="submit"
                  elevation="0"
                  large
                  outlined
                  color="green"
                >
                  {{ $t("buttons.add") }}
                </v-btn>
                <v-btn
                  small
                  class="ma-2 mr-4"
                  elevation="0"
                  large
                  outlined
                  color="grey"
                  @click="addRescueModal = false"
                >
                  {{ $t("buttons.cancel") }}
                </v-btn>
              </div>
            </v-card-text>
          </form>
        </ValidationObserver>
      </v-card>
    </v-dialog>
    <!-- Page content -->
    <v-card style="border-radius: 10px">
      <v-card-title style="color: #595959">
        <v-row>
          <v-col class="py-2">{{ $t("title.rescueTeam") }}</v-col>
          <v-spacer />
          <v-btn
            small
            class="ma-2 mr-4"
            elevation="0"
            outlined
            color="info"
            @click="addRescueModal = true"
          >
            {{ $t("buttons.addNew") }}
          </v-btn>
        </v-row>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4"
        ><v-row justify="space-between">
          <v-col cols="2">
            <v-select
              v-model="itemsPerPage"
              :items="perPageValues"
              :label="$t('labels.selectItemsPerPage')"
              item-value="value"
              item-text="name"
              @change="changeItemsPerPage()"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="tableData"
          :loading="loadings.table"
          :options.sync="options"
          :hide-default-footer="true"
          :footer-props="{
            disablePagination: true,
            disableItemsPerPage: true,
          }"
          :no-data-text="$t('description.noList')"
        >
          <!-- eslint-disable -->

          <template v-slot:item.CreatedAt="{ item }">
            {{ convertToLocal(item.CreatedAt) }}
          </template>
          <template v-slot:item.MemberCount="{ item }">
            {{ item.Members.length }}
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template
                v-slot:activator="{ on, attrs }"
                v-if="item.Members.length != 0"
              >
                <v-icon
                  small
                  class="mr-2"
                  @click="openDetailPopup(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-eye
                </v-icon>
              </template>
              <span>{{ $t("labels.tooltipEdit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  class="mr-2"
                  @click="openInsertPopup(item)"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-plus
                </v-icon>
              </template>
              <span>{{ $t("title.addMember") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2 md4 lg4">
          <v-pagination
            @input="paginationChangeHandler"
            :value="pagination.page"
            :length="pages"
            :total-visible="10"
            circle
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DeleteModal from "../components/General/DeleteModal";
import RescueTeamService from "../services/RescueTeamService";

export default {
  data: () => ({
    userDetailModal: false,
    addMemberModal: false,
    selectedAdmins: null,
    adminUsers: null,
    detailTeam: {},
    teamId: null,
    TeamName: "",
    addRescueModal: false,
    // List options
    options: {
      itemsPerPage: 15,
    },
    top: 15,
    skip: 0,
    tableData: [],

    headers: [],
    //Loading states
    loadings: {
      table: false,
      select: false,
      send: false,
    },
    //Group

    //Pagination models
    pagination: {},
    itemsPerPage: 15,
    perPageValues: [10, 15, 30, 50, 100],
  }),

  watch: {},
  mounted() {
    this.setup();
    this.getTableList();
  },
  components: {
    DeleteModal,
  },

  computed: {
    totalRecords() {
      return this.items.length;
    },
    pageCount() {
      return this.totalRecords / this.itemsPerPage;
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      ) {
        return 0;
      }

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
  },

  methods: {
    setup() {
      this.headers = [
        {
          text: "Takım Adı",
          value: "TeamName",
          sortable: false,
          align: "center",
        },
        {
          text: "Üye Sayısı",
          value: "MemberCount",
          sortable: false,
        },
        {
          text: "Oluşturulma Tarihi",
          value: "CreatedAt",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("title.tableHeaderActions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
        (this.pagination = {
          totalItems: 200,
          rowsPerPage: this.itemsPerPage,
          page: 1,
        }),
      ];
    },
    //Fill's the emergency list
    getTableList() {
      this.$store.state.loadingStatus = true;
      this.tableData = [];
      RescueTeamService.getTeams(
        this.pagination.page,
        this.pagination.rowsPerPage
      )
        .then((res) => {
          this.tableData = res.data.Result;
          this.pagination.totalItems = res.data.TotalItems;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },

    openDetailPopup(item) {
      this.detailTeam = item;
      this.userDetailModal = true;
    },
    openInsertPopup(item) {
      this.teamId = item.Id;
      console.log("admins", this.adminUsers);
      this.$store.state.loadingStatus = true;
      RescueTeamService.getAdmins(this.teamId)
        .then((res) => {
          this.adminUsers = res.data.Result;
          this.addMemberModal = true;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    addMembers() {
      this.addMemberModal = false;
      this.$store.state.loadingStatus = true;
      let body = {
        TeamId: this.teamId,
        UserIds: this.selectedAdmins.map(x => x.Id),
      };
      RescueTeamService.addMembers(body)
        .then((res) => {
          this.getTableList();
          this.teamId = null;
          this.selectedAdmins = null;
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    closeModal() {
      this.addMemberModal = false;
      this.selectedAdmins = null;
    },
    openDeleteModal(item) {
      this.deleteUserModel = item;
      this.$refs.deleteModalRef.modalStatus = true;
    },
    deleteItem() {
      this.clearPage();
      this.$store.state.loadingStatus = true;
      let body = {
        TeamId: this.detailTeam.Id,
        UserId: this.deleteUserModel.UserId,
      };
      RescueTeamService.deleteMember(body)
        .then(() => {
          this.getTableList();
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          // this.loadings.table = false;
          this.$store.state.loadingStatus = false;
        });
    },
    addNewRescue() {
      this.clearPage();
      this.$store.state.loadingStatus = true;
      let body = {
        TeamName: this.TeamName,
      };
      RescueTeamService.createTeam(body)
        .then(() => {
          this.getTableList();
        })
        .catch((err) => {
          window.handleServiceError(res, err);
        })
        .then(() => {
          // this.loadings.table = false;
          this.$store.state.loadingStatus = false;
        });
    },
    clearPage() {
      this.$refs.deleteModalRef.modalStatus = false;
      this.userDetailModal = false;
      this.addRescueModal = false;
    },
    //Change displayed items per page, page number one is default
    changeItemsPerPage() {
      this.pagination.rowsPerPage = this.itemsPerPage;
      this.pagination.page = 1;
      this.options.itemsPerPage = this.itemsPerPage;
      this.getTableList();
    },

    //Change list pagination page
    paginationChangeHandler(pageNumber) {
      this.pagination.page = pageNumber;
      this.getTableList();
    },
  },
};
</script>
